var _path, _g, _path2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3738,
    height: 146,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 1246,
    height: 146,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1246v146H0V0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#c)",
    d: "M1167 54.89c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18l-18.5 27.5c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327m2.26.673-2.26-.673m2.26.673c-.77-.23-1.52-.455-2.26-.673m-941.24.673c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.667-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.333 12 52 18l-18.5 27.5c-3.167-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.486 5.35.973 5.496 27.244 13.327l2.256.673ZM436 3.39v132.5h38v-45.5h7.5l25 45.5h45l-33-54c8.333-2.833 25-14.2 25-37 0-28.5-23-41.5-47.5-41.5h-60Zm38 57v-26h18c4.333-.5 13 2.5 13 12.5s-9 13.5-13 13.5h-18Zm-177-57v132.5h99v-33h-60.5v-19h49v-30.5h-49v-17.5H396V3.39h-99Zm267.5 0 48 132.5h45L705 3.39h-42.5l-27 85-27.5-85h-43.5Zm168.5 0v132.5h38.5V3.39H733Zm195.5 14c-6.833-6.833-28.1-19.8-58.5-17-38 3.5-63.528 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.833 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Zm35-14.5v134h99.5v-34h-61v-19.5h49.5v-30H1002v-17.5h60v-33h-98.5Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 1246,
    height: 146,
    x: 1246,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1246 0h1246v146H1246V0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#e)",
    d: "M2413 54.89c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18l-18.5 27.5c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327m2.26.673-2.26-.673m2.26.673c-.77-.23-1.52-.455-2.26-.673m-941.24.673c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18l-18.5 27.5c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327l2.26.673ZM1682 3.39v132.5h38v-45.5h7.5l25 45.5h45l-33-54c8.33-2.833 25-14.2 25-37 0-28.5-23-41.5-47.5-41.5h-60Zm38 57v-26h18c4.33-.5 13 2.5 13 12.5s-9 13.5-13 13.5h-18Zm-177-57v132.5h99v-33h-60.5v-19h49v-30.5h-49v-17.5h60.5V3.39h-99Zm267.5 0 48 132.5h45L1951 3.39h-42.5l-27 85-27.5-85h-43.5Zm168.5 0v132.5h38.5V3.39H1979Zm195.5 14c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Zm35-14.5v134h99.5v-34h-61v-19.5h49.5v-30H2248v-17.5h60v-33h-98.5Z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 1246,
    height: 146,
    x: 2492,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2492 0h1246v146H2492V0Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#g)",
    d: "M3659 54.89c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18l-18.5 27.5c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327m2.26.673-2.26-.673m2.26.673c-.77-.23-1.52-.455-2.26-.673m-941.24.673c28.5 8.5 42 23 39.5 44s-19.5 40-55.5 40c-28.8 0-49.67-12.333-56.5-18.5l18-28.5c6 6 17.5 13 30.5 14.5s25.5 0 25.5-7.5c0-3.5 0-8-25.5-14s-42.5-19.5-42.5-41 18-43.5 53-43.5c28 0 46.33 12 52 18l-18.5 27.5c-3.17-3.167-12.5-10.1-24.5-12.5-15-3-25.5 2-25 7.5.49 5.35.97 5.496 27.24 13.327l2.26.673ZM2928 3.39v132.5h38v-45.5h7.5l25 45.5h45l-33-54c8.33-2.833 25-14.2 25-37 0-28.5-23-41.5-47.5-41.5h-60Zm38 57v-26h18c4.33-.5 13 2.5 13 12.5s-9 13.5-13 13.5h-18Zm-177-57v132.5h99v-33h-60.5v-19h49v-30.5h-49v-17.5h60.5V3.39h-99Zm267.5 0 48 132.5h45L3197 3.39h-42.5l-27 85-27.5-85h-43.5Zm168.5 0v132.5h38.5V3.39H3225Zm195.5 14c-6.83-6.833-28.1-19.8-58.5-17-38 3.5-63.53 33.434-62.5 73 1 38.5 26.5 65.5 72 65.5 28.5 0 44.5-10.5 52-15.5l-17-32.5c-5.83 3.833-19 11-33.5 10.5s-32-7-33.5-28 10-35.5 33.5-35.5c11.5 0 22 3.5 28.5 11l19-31.5Zm35-14.5v134h99.5v-34h-61v-19.5h49.5v-30H3494v-17.5h60v-33h-98.5Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 20.94,
    x2: 191.649,
    y1: 106.069,
    y2: -338.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1266.94,
    x2: 1437.65,
    y1: 106.069,
    y2: -338.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 2512.94,
    x2: 2683.65,
    y1: 106.069,
    y2: -338.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#EDD1CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE052"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h3738v146H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunServices);
export default __webpack_public_path__ + "static/media/run_services.dabbfbcbc3fd7dabd8d74189f02d396e.svg";
export { ForwardRef as ReactComponent };